window.addEventListener('DOMContentLoaded', () => {
    applyLoginFunctionality();
    applyRecoverEmailFunctionality();
});

function applyLoginFunctionality() {
    const signInButton = document.querySelector('.js-login-page-signin-btn');
    signInButton.addEventListener('click', onLoginButtonClick);

    const inputs = document.querySelectorAll('#customer_login input:not([type=hidden])');
    const emailElem = document.querySelector('.js-login-email-field');
    const passwordElem = document.querySelector('.js-login-password-field');

    const state = {
        hasErrors: !!document.querySelector('#login .js-login-form-has-errors'),
        shouldValidate: !!document.querySelector('#login .js-login-form-has-errors'),
    }

    for (const input of inputs) {
        input.addEventListener('input', onInputChange);
    }

    function onInputChange() {
        if (!state.shouldValidate) {
            return;
        }

        const isEmailValid = validateEmailField(emailElem, state);
        const isPasswordValid = validatePasswordField(passwordElem, state);
        state.hasErrors = !isEmailValid || !isPasswordValid;
    }

    function onLoginButtonClick(e) {
        if (!state.shouldValidate) {
            state.shouldValidate = true;
        }

        const isEmailValid = validateEmailField(emailElem, state);
        const isPAsswordValid = validatePasswordField(passwordElem, state);

        if (!isEmailValid || !isPAsswordValid) {
            e.preventDefault();
            return;
        }

        document.getElementById('customer_login').submit();
    }
}

function applyRecoverEmailFunctionality() {
    const state = {
        hasErrors: !!document.querySelector('.js-recover-email-server-error'),
        shouldValidate: false,
    }
    const emailElem = document.querySelector('.js-recover-email-elem');
    const emailInput = emailElem.querySelector('input');
    const submitButton = document.querySelector('.js-recover-submit-btn');

    emailInput.addEventListener('input', onInputChange);

    submitButton.addEventListener('click', (e) => {
        state.shouldValidate = true;
        state.hasErrors = !validateEmailField(emailElem, state);
        if (state.hasErrors) {
            e.preventDefault();
        }
    });

    function onInputChange() {
        validateEmailField(emailElem, state);
    }
}
